<template>
  <article class="success-screen">
    <div>
      <img
        class="success-img"
        src="~@/assets/contact/message-sent.svg"
        alt="message sent!"
      />
      <AdaptiveSpace staticHeight="40px" />
      <div class="success-text">
        <p class="success-title">{{ $t('contact.success_header') }}</p>
        <p class="success-subtitle">
          {{ $t('contact.success_text') }}
        </p>
      </div>
      <AdaptiveSpace :adaptiveHeight="['40px', '150px']" />
      <router-link to="/"
        ><button class="home-button">{{ $t('contact.success_button') }}</button>
      </router-link>
    </div>
  </article>
</template>

<script>
import AdaptiveSpace from '../Registration/AdaptiveSpace.vue';

export default {
  name: 'ScreenSuccess',
  components: { AdaptiveSpace },
};
</script>

<style scoped>
.success-screen {
  margin-top: 5em;
  display: grid;
  margin-left: 36px;
  margin-right: 36px;
  place-items: center;
  min-height: 523px;
  --success-title-f-size: 16px;
  --success-subtitle-f-size: 14px;
  --success-btn-f-size: 14px;
}

.success-img {
  margin: 0 auto;
  display: block;
}
.success-title {
  font-weight: bold;
  margin: 0 auto;
  font-size: var(--success-title-f-size);
  width: max-content;
}
.success-subtitle {
  font-size: var(--success-subtitle-f-size);
  margin-top: 8px;
}

.home-button {
  background: #2b4047;
  color: white;
  width: 100%;
  height: 35px;
  border-radius: 30px;
  font-size: var(--success-btn-f-size);
}
@media (min-width: 1224px) {
  .success-screen {
    --success-title-f-size: 18px;
    --success-subtitle-f-size: 16px;
    --success-btn-f-size: 20px;
  }
}
@media (min-width: 1279px) {
  .success-screen {
    margin-right: 0;
    margin-left: 10%;
    margin-top: 0;
  }
}
@media (min-width: 1600px) {
  .success-screen {
    --success-title-f-size: 20px;
  }
}
</style>
